
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dontgiftguide",
      function () {
        return require("private-next-pages/dontgiftguide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dontgiftguide"])
      });
    }
  